import React from "react";
import Footer from "../components/Footer/Footer";
import LoginForm from "../components/LoginForm/LoginForm";
import Navbar from "../components/Navbar/Navbar";

const Login = () => {
    return (
        <>
            <Navbar />
            <LoginForm />
            <Footer />
        </>
    )
}

export default Login;
